const suitSymbols = {
  spade: "♠",
  heart: "♥",
  diamond: "♦",
  club: "♣"
};

const suitColors = {
  spade: "text-gray-900",
  heart: "text-red-600",
  diamond: "text-red-600",
  club: "text-gray-900",
  hidden: "text-muted-foreground"
};

export default function PlayingCard({ 
  suit, 
  rank, 
  isPublic = true, 
  isSelected = false,
  size = "md",
  showBack = false 
}) {
  const sizeClasses = {
    xxs: "w-6 h-8",
    xs: "w-8 h-11",
    sm: "w-10 h-14",
    md: "w-14 h-20",
    lg: "w-16 h-24 md:w-20 md:h-28"
  };

  const fontSizes = {
    xxs: "text-[8px]",
    xs: "text-xs",
    sm: "text-sm",
    md: "text-lg",
    lg: "text-xl md:text-2xl"
  };

  const symbolSizes = {
    xxs: "text-[10px]",
    xs: "text-sm",
    sm: "text-lg",
    md: "text-2xl",
    lg: "text-3xl md:text-4xl"
  };

  // Hidden card (card back)
  if (suit === "hidden" || showBack) {
    return (
      <div 
        className={`${sizeClasses[size]} rounded-xl border-2 border-brass/50 bg-gradient-to-br from-emerald-900 to-emerald-950 relative overflow-hidden shadow-md`}
        data-testid="card-hidden"
      >
        <div className="absolute inset-1.5 border border-brass/20 rounded-lg">
          <div className="absolute inset-0 opacity-30" style={{
            backgroundImage: `repeating-linear-gradient(
              45deg,
              transparent,
              transparent 3px,
              rgba(197, 160, 89, 0.2) 3px,
              rgba(197, 160, 89, 0.2) 6px
            )`
          }} />
        </div>
      </div>
    );
  }

  const color = suitColors[suit];
  const symbol = suitSymbols[suit];

  return (
    <div 
      className={`${sizeClasses[size]} rounded-xl bg-white shadow-md relative overflow-hidden transition-all ${
        isSelected ? "ring-2 ring-brass shadow-lg" : ""
      }`}
      data-testid={`card-${suit}-${rank}`}
    >
      {/* Simple card design: rank + suit */}
      <div className={`absolute inset-0 flex flex-col items-center justify-center ${color}`}>
        <span className={`font-bold ${fontSizes[size]}`}>{rank}</span>
        <span className={`${symbolSizes[size]}`}>{symbol}</span>
      </div>

      {/* Private indicator */}
      {!isPublic && (
        <div className="absolute top-0 right-0 bg-amber-500 text-white text-[10px] px-1 rounded-bl-lg font-bold">
          秘
        </div>
      )}
    </div>
  );
}
